// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Link = require("./link");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Fetch = require("bs-fetch/lib/js/src/Fetch.js");
var Theme = require("./theme");
var React = require("react");
var Network = require("./network");
var Storage = require("./storage");
var Json_encode = require("@glennsl/bs-json/lib/js/src/Json_encode.bs.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Login_iconSvg = require("./assets/login_icon.svg");
var Mail_inputSvg = require("./assets/mail_input.svg");
var Password_inputSvg = require("./assets/password_input.svg");

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var login = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var loginHeadBox = Css.style(/* :: */[
      Css.position(Css.relative),
      /* :: */[
        Css.textAlign(Css.center),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.flexDirection(Css.column),
                /* :: */[
                  Css.margin4(Css.px(20), Css.px(0), Css.px(0), Css.px(0)),
                  /* :: */[
                    Css.fontSize(Css.px(24)),
                    /* :: */[
                      Css.width(Css.px(110)),
                      /* :: */[
                        Css.height(Css.px(110)),
                        /* :: */[
                          Css.borderRadius(/* `percent */[
                                -119887163,
                                50.0
                              ]),
                          /* :: */[
                            Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                            /* [] */0
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var loginIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.1,
                  1.1
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      -50.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.left(/* `percent */[
                  -119887163,
                  52.0
                ]),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(35)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var inputBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* :: */[
                Css.padding(Css.px(10)),
                /* :: */[
                  Css.boxSizing(/* borderBox */9307263),
                  /* :: */[
                    Css.position(Css.relative),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var inputFieldBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.position(Css.relative),
            /* :: */[
              Css.boxSizing(/* borderBox */9307263),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding4(Css.px(5), Css.px(10), Css.px(5), Css.px(50)),
        /* :: */[
          Css.fontSize(Css.px(18)),
          /* :: */[
            Css.minHeight(Css.px(40)),
            /* :: */[
              Css.maxWidth(Css.px(300)),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.minWidth(Css.px(220)),
                  /* :: */[
                    Css.borderRadius(/* `px */[
                          25096,
                          50
                        ]),
                    /* :: */[
                      Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                            5194459,
                            "F492BD"
                          ]),
                      /* :: */[
                        Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                        /* :: */[
                          Css.boxSizing(/* borderBox */9307263),
                          /* :: */[
                            Css.position(Css.relative),
                            /* [] */0
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var mailInput = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.2,
                  1.2
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      0.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.left(Css.px(18)),
          /* :: */[
            Css.position(/* absolute */-1013592457),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(25)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var passwordInput = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.05,
                  1.05
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      0.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.left(Css.px(18)),
          /* :: */[
            Css.position(/* absolute */-1013592457),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(21)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* login */login,
  /* loginHeadBox */loginHeadBox,
  /* loginIcon */loginIcon,
  /* inputBox */inputBox,
  /* inputFieldBox */inputFieldBox,
  /* inputField */inputField,
  /* mailInput */mailInput,
  /* passwordInput */passwordInput,
  /* someLink */someLink
];

function text(prim) {
  return prim;
}

function validateEmail(value) {
  var emailRegex = (/.*@.*\..+/);
  if (value === "") {
    return /* Some */["Email Feld leer"];
  } else if (emailRegex.test(value)) {
    return /* None */0;
  } else {
    return /* Some */["Email Adresse enthält Fehler"];
  }
}

function validatePassword(value) {
  var match = +(value.length > 5);
  if (match !== 0) {
    return /* PassValid */0;
  } else {
    return /* PassNotValid */["Password zu kurz"];
  }
}

function logUserIn(data) {
  return Promise.resolve(data).then((function (prim) {
                      return prim.json();
                    })).then((function (json) {
                    Network.initializeSyncStatus2(Storage.setAccessTokenandExpiry(Storage.decodedTokenData(json)));
                    Network.pullData("", Network.successSyncAll);
                    return Promise.resolve(/* () */0);
                  })).then((function () {
                  console.log("all done for login !!!!!!");
                  return Promise.resolve(/* () */0);
                })).catch((function (err) {
                return Promise.resolve((console.log("Login response parse error", err), /* () */0));
              }));
}

function showPasswordError(data, self) {
  return Promise.resolve(data).then((function () {
                  console.log("Login error!");
                  Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(2, ["Logindaten nicht korrekt"]));
                  return Promise.resolve(/* () */0);
                })).catch((function (err) {
                return Promise.resolve((console.log("Login error exception", err), /* () */0));
              }));
}

function showOtherError(data) {
  return Promise.resolve(data).then((function () {
                  console.log("Other error!");
                  return Promise.resolve(/* () */0);
                })).catch((function (err) {
                return Promise.resolve((console.log("Other http error exception", err), /* () */0));
              }));
}

var component = ReasonReact.reducerComponent("Login");

function make() {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (param) {
      var send = param[/* send */4];
      var state = param[/* state */2];
      var match = state[/* localStorageSupported */4];
      if (match !== 0) {
        var match$1 = state[/* error */2];
        var match$2 = state[/* loading */3];
        return React.createElement("div", {
                    className: login
                  }, React.createElement("div", {
                        className: loginHeadBox
                      }, React.createElement("img", {
                            className: loginIcon,
                            alt: "icon",
                            src: Login_iconSvg
                          })), React.createElement("h1", undefined, "Login"), React.createElement("div", {
                        className: inputBox
                      }, React.createElement("div", {
                            className: inputFieldBox
                          }, React.createElement("input", {
                                className: inputField,
                                autoFocus: true,
                                placeholder: "Email",
                                type: "email",
                                value: state[/* email */0],
                                onChange: (function ($$event) {
                                    return Curry._1(send, /* ChangeEmail */Block.__(0, [$$event.target.value]));
                                  })
                              }), React.createElement("img", {
                                className: mailInput,
                                alt: "mail",
                                src: Mail_inputSvg
                              })), React.createElement("div", {
                            className: inputFieldBox
                          }, React.createElement("input", {
                                className: inputField,
                                placeholder: "Passwort",
                                type: "password",
                                value: state[/* password */1],
                                onKeyDown: (function ($$event) {
                                    if ($$event.keyCode === 13) {
                                      $$event.preventDefault();
                                      return Curry._1(send, /* NewLoginEnterKeyDown */1);
                                    } else {
                                      return Curry._1(send, /* NewLoginOtherKeyDown */0);
                                    }
                                  }),
                                onChange: (function ($$event) {
                                    return Curry._1(send, /* ChangePassword */Block.__(1, [$$event.target.value]));
                                  })
                              }), React.createElement("img", {
                                className: passwordInput,
                                alt: "pass",
                                src: Password_inputSvg
                              }))), match$1 ? React.createElement("div", {
                          className: "failure"
                        }, match$1[0]) : null, React.createElement("button", {
                        className: Theme.simpleButton(/* () */0),
                        onClick: (function () {
                            return Curry._1(send, /* Login */2);
                          })
                      }, match$2 !== 0 ? React.createElement("div", {
                              className: "button-spinner"
                            }) : "Login"), ReasonReact.element(/* None */0, /* None */0, Link.make("/register", "zur Registrierung", someLink, /* array */[])), ReasonReact.element(/* None */0, /* None */0, Link.make("/reset", "zum Passwort Reset", someLink, /* array */[])));
      } else {
        return React.createElement("div", {
                    className: login
                  }, React.createElement("h1", undefined, "Bitte LocalStorage und Cookies zulassen"));
      }
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* email */Network.getUrlParamCode(/* Email */1),
              /* password */"",
              /* error : None */0,
              /* loading : false */0,
              /* localStorageSupported */Storage.localStorageSupported(/* () */0)
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              return /* NoUpdate */0;
          case 1 : 
              return /* SideEffects */Block.__(2, [(function (self) {
                            return Curry._1(self[/* send */4], /* Login */2);
                          })]);
          case 2 : 
              var emailValid = validateEmail(state[/* email */0]);
              if (emailValid) {
                var error = emailValid[0];
                return /* SideEffects */Block.__(2, [(function (self) {
                              return Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(2, [error]));
                            })]);
              } else {
                var passwordValid = validatePassword(state[/* password */1]);
                if (passwordValid) {
                  var error$1 = passwordValid[0];
                  return /* SideEffects */Block.__(2, [(function (self) {
                                return Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(2, [error$1]));
                              })]);
                } else {
                  return /* UpdateWithSideEffects */Block.__(3, [
                            /* record */[
                              /* email */state[/* email */0],
                              /* password */state[/* password */1],
                              /* error */state[/* error */2],
                              /* loading : true */1,
                              /* localStorageSupported */state[/* localStorageSupported */4]
                            ],
                            (function (self) {
                                var requestPayload = Json_encode.object_(/* :: */[
                                      /* tuple */[
                                        "client_id",
                                        Network.mBBClientId
                                      ],
                                      /* :: */[
                                        /* tuple */[
                                          "client_secret",
                                          Network.mBBClientSecret
                                        ],
                                        /* :: */[
                                          /* tuple */[
                                            "grant_type",
                                            Network.grantType
                                          ],
                                          /* :: */[
                                            /* tuple */[
                                              "username",
                                              self[/* state */2][/* email */0]
                                            ],
                                            /* :: */[
                                              /* tuple */[
                                                "password",
                                                self[/* state */2][/* password */1]
                                              ],
                                              /* [] */0
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]);
                                fetch(Network.loginUrl, Fetch.RequestInit[/* make */0](/* Some */[/* Post */2], /* Some */[{
                                                  "Content-Type": "application/json",
                                                  Accept: "application.json"
                                                }], /* Some */[JSON.stringify(requestPayload)], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0)(/* () */0)).then((function (data) {
                                          var statusCode = data.status;
                                          console.log("https status: ", statusCode);
                                          if (statusCode !== 200) {
                                            if (statusCode !== 400) {
                                              Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(2, ["Loginfehler"]));
                                              return showOtherError(data);
                                            } else {
                                              return showPasswordError(data, self);
                                            }
                                          } else {
                                            return logUserIn(data);
                                          }
                                        })).catch((function (err) {
                                        return Promise.resolve((console.log("api error login", err), Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(2, ["Netzwerkfehler"]))));
                                      }));
                                return /* () */0;
                              })
                          ]);
                }
              }
          case 3 : 
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* email */state[/* email */0],
                          /* password */state[/* password */1],
                          /* error */state[/* error */2],
                          /* loading : false */0,
                          /* localStorageSupported */state[/* localStorageSupported */4]
                        ],
                        (function () {
                            return ReasonReact.Router[/* push */0]("/dashboard");
                          })
                      ]);
          case 4 : 
              return /* Update */Block.__(0, [/* record */[
                          /* email */state[/* email */0],
                          /* password */state[/* password */1],
                          /* error : None */0,
                          /* loading */state[/* loading */3],
                          /* localStorageSupported */state[/* localStorageSupported */4]
                        ]]);
          
        }
      } else {
        switch (action.tag | 0) {
          case 0 : 
              return /* Update */Block.__(0, [/* record */[
                          /* email */action[0],
                          /* password */state[/* password */1],
                          /* error */state[/* error */2],
                          /* loading */state[/* loading */3],
                          /* localStorageSupported */state[/* localStorageSupported */4]
                        ]]);
          case 1 : 
              return /* Update */Block.__(0, [/* record */[
                          /* email */state[/* email */0],
                          /* password */action[0],
                          /* error */state[/* error */2],
                          /* loading */state[/* loading */3],
                          /* localStorageSupported */state[/* localStorageSupported */4]
                        ]]);
          case 2 : 
              var text = action[0];
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* email */state[/* email */0],
                          /* password */state[/* password */1],
                          /* error : Some */[text],
                          /* loading : false */0,
                          /* localStorageSupported */state[/* localStorageSupported */4]
                        ],
                        (function (self) {
                            console.log("ShowErrorMessage Reducer:", text);
                            setTimeout((function () {
                                    return Curry._1(self[/* send */4], /* ClearError */4);
                                  }), 2500);
                            return /* () */0;
                          })
                      ]);
          
        }
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.validateEmail = validateEmail;
exports.validatePassword = validatePassword;
exports.logUserIn = logUserIn;
exports.showPasswordError = showPasswordError;
exports.showOtherError = showOtherError;
exports.component = component;
exports.make = make;
/* card Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/login.re
// module id = 108
// module chunks = 0